import React, { useMemo, useRef } from "react";
import { useAccordion } from "../hooks/useAccordion";
import { StyledAccordionItem, Content } from "../styled";
import { AccordionTitle } from "./AccordionTitle";
export var AccordionItem = function (_a) {
    var contentBackgroundColour = _a.contentBackgroundColour, id = _a.id, itemBorderColour = _a.itemBorderColour, children = _a.children, title = _a.title, titleBackgroundColour = _a.titleBackgroundColour, titleColor = _a.titleColor, titleFontSize = _a.titleFontSize;
    var _b = useAccordion(), activeId = _b.activeId, onAccordionClick = _b.onAccordionClick;
    var internalId = useRef(getInternalId(title, id));
    if (!internalId.current && process.env.ENV_NAME === "local") {
        console.error("[Accordion] No internal ID found. If you are using a React component for the title, you need to provide an id prop too.");
    }
    var isOpen = useMemo(function () { return activeId === internalId.current; }, [internalId, activeId]);
    return (React.createElement(StyledAccordionItem, { borderColour: itemBorderColour, id: internalId.current },
        React.createElement(AccordionTitle, { backgroundColour: titleBackgroundColour, titleColor: titleColor, titleFontSize: titleFontSize, isOpen: isOpen, onClick: function () { return onAccordionClick(internalId.current); }, title: title }),
        isOpen && (React.createElement(Content, { backgroundColour: contentBackgroundColour, isOpen: isOpen }, children))));
};
function getInternalId(title, id) {
    return !!id ? id : isString(title) ? title : "";
}
function isString(title) {
    return typeof title === "string";
}
